import { Plus } from '@phosphor-icons/react';

export default Plus;
